import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
/**
 * The list's two filters live in the URL as separate params so Back, refresh,
 * shared links and a round-trip to a Landscape's detail restore them:
 * `landscape` narrows to one Landscape, `org` to Landscapes scoped to an organization.
 */ export function useLandscapeParams() {
    const [params, setParams] = useSearchParams();
    const landscape = params.get('landscape') ?? '';
    const organization = params.get('org') ?? '';
    const write = useCallback((key, value)=>setParams((prev)=>{
            const next = new URLSearchParams(prev);
            if (value) next.set(key, value);
            else next.delete(key);
            return next;
        }, {
            replace: true
        }), [
        setParams
    ]);
    return {
        landscape,
        organization,
        search: params.toString() ? `?${params.toString()}` : '',
        setLandscape: useCallback((v)=>write('landscape', v), [
            write
        ]),
        setOrganization: useCallback((v)=>write('org', v), [
            write
        ])
    };
}
